export default __webpack_public_path__ + "static/media/muhammadalimughal.562608d3.jpeg";